"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line no-use-before-define
const react_1 = __importDefault(require("react"));
const StocksView_1 = __importDefault(require("./StocksView"));
const StockRecordsView_1 = __importDefault(require("../StockRecordsView"));
const StockInfosDownloaderView_1 = __importDefault(require("./Downloader/StockInfosDownloaderView"));
const StockManagementView_1 = __importDefault(require("./StockManagementView"));
function CenterStockManagement({ path, client, }) {
    return (react_1.default.createElement(StockManagementView_1.default, { client: client, path: path, stocksView: (props) => (react_1.default.createElement(StocksView_1.default, Object.assign({ hasCost: true }, props))), stockRecordsView: (props) => react_1.default.createElement(StockRecordsView_1.default, Object.assign({ assertViewPath: "centerAssertManagement", path: path }, props)), downloadView: (props) => StockInfosDownloaderView_1.default(Object.assign(Object.assign({}, props), { showCost: true })) }));
}
exports.default = CenterStockManagement;
